module.exports = __webpack_public_path__ + "assets/img/arrow-right.9356c3d0.svg";